import { createStyleSheet } from '@shared-ui/theme'

export const useCreateStyles = createStyleSheet((theme) => ({
  provider: { flex: 1, minHeight: 0 },
  webview: { flex: 1, width: '100%', height: '100%', borderWidth: 0, backgroundColor: theme.COLOR_BG_BASE },
  loader: {
    position: 'absolute',
    inset: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.COLOR_BG_BASE,
  },
}))
